import './hero-slider/frontend';